module.exports = __webpack_public_path__ + "static/media/clinicMarker.6449c2f6.png";